import { render } from "./TccDocsUploads.vue?vue&type=template&id=3ec4317c&scoped=true"
import script from "./TccDocsUploads.vue?vue&type=script&lang=js"
export * from "./TccDocsUploads.vue?vue&type=script&lang=js"

import "./TccDocsUploads.vue?vue&type=style&index=0&id=3ec4317c&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec4317c"]])

export default __exports__